import { type ErrorComponentProps, GeneralError } from '@openx/components/core';
import type { ReactNode } from 'react';
import { ErrorBoundary as ErrorBoundaryWrapper } from 'react-error-boundary';
import type Rollbar from 'rollbar';

type ErrorBoundaryProps = {
  children: ReactNode;
  rollbar?: Rollbar;
  redirectTo?: string;
  errorProps?: ErrorComponentProps;
};

function logError(rollbar: Rollbar | undefined) {
  return (error: Error, info?: { componentStack?: string | null }) => {
    // biome-ignore lint/suspicious/noConsole: we want to log this error
    console.error('ErrorBoundary', error, info?.componentStack);

    rollbar && rollbar.error(error);
  };
}

export function ErrorBoundary({ children, rollbar, redirectTo, errorProps }: ErrorBoundaryProps): JSX.Element {
  const onClick = () => {
    window.location.href = redirectTo || '/';
  };

  return (
    <ErrorBoundaryWrapper
      fallbackRender={() => <GeneralError onClick={onClick} data-test="error-refresh" {...errorProps} />}
      onError={logError(rollbar)}
    >
      {children}
    </ErrorBoundaryWrapper>
  );
}
